import useSwr, { type SWRResponse } from 'swr'

import {
  type DictionaryDto,
  SellerCentralProxyApiFactory,
} from '@redteclab/api/clients/composition-service-marketplace'

import { useGlooApi } from '../../../api'
import { useGlobalConfigContext } from '../../../global-config'

const getMarketplacePartnerRegisterApiSwrGetDictionariesKey = (): string => {
  return 'marketplacePartnerRegisterApiSwrGetDictionaries'
}

export const useMarketplacePartnerRegisterApiSwrGetDictionaries =
  (): SWRResponse<DictionaryDto[]> => {
    const config = useGlobalConfigContext()
    const client = useGlooApi(SellerCentralProxyApiFactory)

    const fetcher = async (): Promise<DictionaryDto[]> => {
      const response =
        await client.compositionServiceMarketplaceApiSellerDictionaries({
          language: config.language,
          tenant: config.tenantAndEnv,
        })

      return response.data
    }

    return useSwr<DictionaryDto[]>(
      getMarketplacePartnerRegisterApiSwrGetDictionariesKey(),
      fetcher,
    )
  }
